module.exports = __webpack_public_path__ + "static/img/regist_bg.a64166a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regist_bg.png
// module id = Ieji
// module chunks = 2